module.exports = __webpack_public_path__ + "img/DOSTLogo.3f3473b9.png";